/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EasyClaimAppState = {
	Onboarding: 'Onboarding',
	Landing: 'Landing',
	VehicleInformation: 'VehicleInformation',
	VehicleImages: 'VehicleImages',
	DamageImages: 'DamageImages',
	DamageDescription: 'DamageDescription',
	Review: 'Review',
	WaitForAudit: 'WaitForAudit',
	Callback: 'Callback',
	Approval: 'Approval',
	ThankYou: 'ThankYou',
	Finished: 'Finished',
	Payout: 'Payout',
	WithoutPayout: 'WithoutPayout',
	Bodyshop: 'Bodyshop',
	Feedback: 'Feedback',
	Upload: 'Upload',
	InsuranceExpert: 'InsuranceExpert',
	PoliceReport: 'PoliceReport',
	ThanksForFeedback: 'ThanksForFeedback',
	Unknown: 'Unknown',
	ResolveRequest: 'ResolveRequest',
	ImpactDirection: 'ImpactDirection',
	SimpleApproval: 'SimpleApproval',
	PerpetratorStatement: 'PerpetratorStatement',
	VinPicture: 'VinPicture',
	AdditionalDocuments: 'AdditionalDocuments',
	DashboardMileage: 'DashboardMileage',
	NecessaryDocuments: 'NecessaryDocuments',
	Timeout: 'Timeout',
	PolicyCheckVehicleImages: 'PolicyCheckVehicleImages',
	VehicleFrontPerspectiveImage: 'VehicleFrontPerspectiveImage',
	VehicleRightPerspectiveImage: 'VehicleRightPerspectiveImage',
	VehicleRearPerspectiveImage: 'VehicleRearPerspectiveImage',
	VehicleLeftPerspectiveImage: 'VehicleLeftPerspectiveImage',
	FourDiagonalPerspectives: 'FourDiagonalPerspectives',
	OverallDashboardImage: 'OverallDashboardImage',
	WindshieldImage: 'WindshieldImage',
	FourAdditionalPictures: 'FourAdditionalPictures',
	TooManyAttempts: 'TooManyAttempts',
	FourAdditionalPicturesAZCEE: 'FourAdditionalPicturesAZCEE',
	ReviewMapfre: 'ReviewMapfre',
	DigitalVerification: 'DigitalVerification',
	FourAdditionalDocuments: 'FourAdditionalDocuments',
	LandingApproval: 'LandingApproval',
	NoOffer: 'NoOffer',
	BankDetails: 'BankDetails',
	CashSettlementOffer: 'CashSettlementOffer',
	OfferAccepted: 'OfferAccepted',
	OfferRejected: 'OfferRejected',
	Redirect: 'Redirect',
	OnboardingStart: 'OnboardingStart',
	VehicleFrontLeftPerspectiveImage: 'VehicleFrontLeftPerspectiveImage',
	VehicleRearLeftPerspectiveImage: 'VehicleRearLeftPerspectiveImage',
	VehicleRearRightPerspectiveImage: 'VehicleRearRightPerspectiveImage',
	VehicleFrontRightPerspectiveImage: 'VehicleFrontRightPerspectiveImage',
	Questions: 'Questions',
	AdditionalDamagePictures: 'AdditionalDamagePictures',
	VehicleRegistrationDocument: 'VehicleRegistrationDocument',
} as const;
export type EasyClaimAppState = (typeof EasyClaimAppState)[keyof typeof EasyClaimAppState];

export function instanceOfEasyClaimAppState(value: any): boolean {
	for (const key in EasyClaimAppState) {
		if (Object.prototype.hasOwnProperty.call(EasyClaimAppState, key)) {
			if (EasyClaimAppState[key as keyof typeof EasyClaimAppState] === value) {
				return true;
			}
		}
	}
	return false;
}

export function EasyClaimAppStateFromJSON(json: any): EasyClaimAppState {
	return EasyClaimAppStateFromJSONTyped(json, false);
}

export function EasyClaimAppStateFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EasyClaimAppState {
	return json as EasyClaimAppState;
}

export function EasyClaimAppStateToJSON(value?: EasyClaimAppState | null): any {
	return value as any;
}

export function EasyClaimAppStateToJSONTyped(
	value: any,
	ignoreDiscriminator: boolean
): EasyClaimAppState {
	return value as EasyClaimAppState;
}
